export const handleToRentLandingRouting = (url: string) => {
    const isToRentLanding = url === '/to-rent/';

    if (isToRentLanding) {
        window.location.assign(url);
    }
};
